module.exports = __webpack_public_path__ + "static/img/index2.069fc1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/vibrate/BY_S07/index2.png
// module id = F812
// module chunks = 0